module.exports = __webpack_public_path__ + "static/img/limit_white_01.f701c92f.svg";